<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Orders from '../components/Orders.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 
    import { DatePicker } from "@svelte-plugins/datepicker";
    import Pagination from '../components/Pagination.svelte'; 
    import { updateUrlParam } from '../base/url.js';
    import { format } from 'date-fns';
    import UploadPopup from '../components/UploadPopup.svelte'; 

    let isLoading = false;
    let uploadPopupShow = false;;

    const today = new Date();

    const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

    const getDateFromToday = (days) => {
        return Date.now() - days * MILLISECONDS_IN_DAY;
    };

    let startDate = getDateFromToday(29);
    let endDate = today;
    let dateFormat = 'MMM d, yyyy';
    let isOpen = false;
    let DateAlign = "center";
    let searchTerm = '';
    let formattedStartDate = '';
    let scannedBarcode = '';

    let prevsearchTerm = '';
    let pages = 1;
    let limit = "50";
    let currentPage = 1;
    let count = 0;
    let urlParams = {}
    let tabSelected = 1;
    let tabStore = 1;
    let customers_count = 0;
    

    const onClearDates = () => {
        startDate = '';
        endDate = '';
    };

    const toggleDatePicker = () => (isOpen = !isOpen);
    const formatDate = (dateString) => dateString && format(new Date(dateString), dateFormat) || '';

    $: formattedStartDate = formatDate(startDate);
    $: formattedEndDate = formatDate(endDate);

    

    let customers = {
        data : []
    };
    let orders = [];    


    

    
    onMount(async() => {

        //console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }

        
        if ($UserStore.manager=="1"){
            push('/customers');
            return;
        }

        
        isLoading = true;

        await get_shipments();

        document.addEventListener('keydown', handleKeyDown);
        
    })    


    onDestroy(() => {
        document.removeEventListener('keydown', handleKeyDown);
    });

    const handleSubmit =  async () => {
        //alert(1)
    }


    let scannedOrderId = '';

    function handleKeyDown(event) {

        if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.isContentEditable) {
            return;
        }

        // Check if the key pressed is a number or Enter
        if (/^\d$/.test(event.key)) {

            scannedOrderId += event.key;

        } else if (event.key === 'Enter') {

            console.log('scannedOrderId',scannedOrderId)

            push('/shipment/'+scannedOrderId)            

            scannedBarcode = '';

           
        }
    }

    const get_shipments = async(filters={}) => {

        const url = new URL(window.location);
        const hashParams = new URLSearchParams(url.hash.split('?')[1]);
        const pageParam = hashParams.get('page');
        const searchParam = hashParams.get('search');
        const tab = hashParams.get('tab');
        const store = hashParams.get('store');
        const limit_amount = hashParams.get('limit');


        if (searchParam) {
            searchTerm = searchParam;
            filters.search = searchTerm;
        }

        if (pageParam) {
            currentPage = pageParam;
        } 
        
        if (tab) {
            tabSelected = tab;
            filters.tab = tab;
        } 

        if (store) {
            tabStore = store;
            filters.store = store;
        } 

        if (limit_amount) {
            limit = limit_amount            
        } 
              

        if (prevsearchTerm!=searchTerm) {
            currentPage = 1;  
            urlParams.page = currentPage;     
            updateUrlParam(urlParams)              
        }


        let postData = {};
        postData.action = 'crm_get_shipments';
        postData.token = $UserStore.data
        postData.filters = filters;  
        postData.limit = parseInt(limit);
        postData.page = currentPage;

        isLoading = true;  

        let data = await fetchData(postData);

        isLoading = false;    

        count = data.count;
        pages = Math.ceil(data.count / parseInt(limit));

        // console.log('count',count,'pages',pages)

        if (data.data) {           

            orders = data.data.filter((item) => {
                
                if (item.date) {
                    const dateTimeParts = item.date.split(" ");
                    item.current_date = dateTimeParts[0];
                    item.current_time = dateTimeParts[1];
                }
                if (item.ncode!=null && item.ncode!='') {
                    item.type = 2; 
                    //pickup_count++;
                } else {
                    item.type = 1; 
                    //door_count++;                    
                }
                return true; 
            });
        }





    }

    const filterOrders = async() => {

        urlParams.search = searchTerm
        updateUrlParam(urlParams);
        await get_shipments();     

    }


    const previous = async(event) => {

        currentPage = event.detail.currentPage;
        urlParams.page = currentPage
        urlParams.limit = limit.toString()
        urlParams.tab = tabSelected
        urlParams.store = tabStore;
        updateUrlParam(urlParams);
        get_shipments();

    }

    const next = async(event) => {

        currentPage = event.detail.currentPage;        
        urlParams.page = currentPage
        urlParams.limit = limit.toString()
        urlParams.tab = tabSelected
        urlParams.store = tabStore;
        updateUrlParam(urlParams);  
        get_shipments();    
    }

    const tabSelect = async() => {
        urlParams.limit = limit.toString()
        urlParams.tab = tabSelected
        urlParams.store = tabStore;
        updateUrlParam(urlParams);  
        get_shipments();    
    }

    const updateLimit = async()=> {
        urlParams.limit = limit.toString()
        urlParams.tab = tabSelected
        urlParams.store = tabStore;
        updateUrlParam(urlParams);  
        get_shipments();    
    }

    const showUploadPopup = async()=> {

        uploadPopupShow = !uploadPopupShow;

    }




    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    {#if uploadPopupShow}
    <UploadPopup on:showUploadPopup={showUploadPopup} />
    {/if}
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">        

            <div class="orders-top">
                <div class="orders-top-up">
                    <h1 class="font-bold">{$_('orders.shipments')}</h1>
                </div>
                
                <form id="orders-filters" class="orders-filters flex justify-between flex-col-reverse md:flex-row" on:submit|preventDefault={handleSubmit}>
                    <div class="flex gap-1">
                        <!-- <select>
                            <option value="">{$_('orders.choose_type')}</option>
                            <option value="1">{$_('orders.type1')}</option>
                            <option value="2">{$_('orders.type2')}</option>
                        </select> -->
                        <!-- <DatePicker bind:isOpen bind:startDate isRange showPresets bind:DateAlign>
                            <div class="date-field" on:click={toggleDatePicker} class:open={isOpen}>
                                <i class="icon-calendar" />
                                <div class="date">
                                {#if startDate}
                                    {formattedStartDate} - {formattedEndDate}
                                {:else}
                                    Pick a date
                                {/if}
                                </div>
                                {#if startDate}
                                <span on:click={onClearDates}>
                                    <i class="os-icon-x" />
                                </span>
                                {/if}
                            </div>
                        </DatePicker> -->
                        <input type="text" placeholder="{$_('orders.free_text')}" bind:value={searchTerm}>
                        <button type="submit" on:click={()=> filterOrders() }>{$_('orders.filter')}</button>
                    </div>
                    <div class="flex flex-row gap-2">
                        <span on:click={()=> showUploadPopup() } class="create_button"><span><i class="fa-solid fa-file-arrow-up"></i> {$_('orders.upload_file')}</span></span>
                        <span on:click={()=> push('/shipment/-1' ) } class="create_button"><span>{$_('orders.create_shipment')}</span></span>
                    </div>
                </form>
            </div>
            <div class="sort_flex">
                {#if $UserStore.id==2353}
                <div class="order_tabs">
                    <!-- <div class:selected={ tabStore == 1 } on:click={()=>{ tabStore = 1; tabSelect(); }}>VANS</div>
                    <div class:selected={ tabStore == 3 } on:click={()=>{ tabStore = 3; tabSelect(); }}>VANS RETURNS</div> -->
                    <div class:selected={ tabStore == 4 } on:click={()=>{ tabStore = 4; tabSelect(); }}>TNF</div>                        
                    <div class:selected={ tabStore == 6 } on:click={()=>{ tabStore = 6; tabSelect(); }}>TNF RETURNS</div>
                </div>
                {/if}
                <div class="order_tabs">
                    <div class:selected={ tabSelected == 1 } on:click={()=>{ tabSelected = 1; tabSelect(); }}>{$_('orders.all_orders')} {#if tabSelected == 1 && !isLoading}({count}){/if}</div>
                    <div class:selected={ tabSelected == 2 } on:click={()=>{ tabSelected = 2; tabSelect(); }}>{$_('orders.open_orders')} {#if tabSelected == 2 && !isLoading}({count}){/if}</div>
                    <div class:selected={ tabSelected == 3 } on:click={()=>{ tabSelected = 3; tabSelect(); }}>{$_('orders.closed_orders')} {#if tabSelected == 3 && !isLoading}({count}){/if}</div>
                    <div class:selected={ tabSelected == 4 } on:click={()=>{ tabSelected = 4; tabSelect(); }}>{$_('orders.one_item')} {#if tabSelected == 4 && !isLoading}({count}){/if}</div>
                    <div class:selected={ tabSelected == 5 } on:click={()=>{ tabSelected = 5; tabSelect(); }}>{$_('orders.multi_items')} {#if tabSelected == 5 && !isLoading}({count}){/if}</div>
                </div>
                <div class="order_sort">
                    <select bind:value={limit} on:change={updateLimit}>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="400">400</option>
                        <option value="400">400</option>
                    </select>
                </div>
            </div>
            <Orders {orders}/>
            <Pagination {pages} on:previous={previous} on:next={next} {currentPage}></Pagination>

        </div>
    </div>
</div>